import axios from "axios";
import Vue from "vue";
import ElementUI from "element-ui";
import i18n from "@/i18n";
import { setStore, getStore, removeStore } from '@/utils/util'
const code = [
  500, 400, 10001, 10002, 20001, 20002, 20003, 20004, 20005, 20006, 20007,
  20008, 20009, 20010, 20011, 20012, 20013, 20014, 20015, 20016, 20018, 20019, 10017, 10018,
  10019, 10020, 10021, 90001, 10022, 10024,
  20017, 20020, 20021, 20022, 20023
];
// 登录请求方法
const loginreq = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
  }).then((res) => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
  var loginUser = JSON.parse(getStore("loginUser"))
  var jwt = loginUser ? loginUser.jwt : ''
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      headers: {
        "Content-Type": "application/json",
        "TRON-ENERGY-USER-TOKEN": jwt
      },
      data: params,
    })
      .then((res) => {
        if (res.data.resultCode === 200) {
          resolve(res.data.data);
        } else {
          // 1. 优先展示后端业务错误信息
          let msg = res.data.errorMessage
            || (window.vm && window.vm.$t && window.vm.$t(res.data.resultCode))
            || (window.vm && window.vm.$t && window.vm.$t('serverError'))
            || '服务器异常，请稍后重试';

          ElementUI.Message.error(msg);

          // 2. 业务错误也把错误对象传递出去，页面catch能拿到
          reject({
            resultCode: res.data.resultCode,
            errorMessage: res.data.errorMessage,
            raw: res.data
          });

          // 3. 登录失效特殊处理
          if (res.data.resultCode === 10002) {
            removeStore('loginUser')
            location.reload()
          }
        }
      })
      .catch((error) => {
        // 网络错误等
        ElementUI.Message.error(window.vm.$t('serverError') || '服务器异常，请稍后重试');
        reject(error);
      });
  });
};

export { loginreq, req };



// WEBPACK FOOTER //
// ./src/api/axiosFun.js